// Not auto-generated.

import { Type } from '@angular/core';

type FieldOf<T> = keyof T & string;

export class ItemBase {
    static Field<T>(this: Type<T>, key: FieldOf<T>): FieldOf<T> {
        return key;
    }
}
